import React from "react";
import { Box } from "./style";
import Modal from "./modal";
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalStatus: false,
      currentShow: 0
    };
  }
  closeModal() {
    this.setState({ modalStatus: false });
  }
  showModal() {
    this.setState({
      modalStatus: true,
      currentShow: 0
    });
  }

  modalView() {
    const { files, loading, onClick, error } = this.props;
    const { modalStatus, currentShow } = this.state;
    return (
      <Modal
        show={modalStatus}
        files={files}
        current={currentShow}
        close={() => this.closeModal()}
        loading={loading}
        error={error}
        getRequest={onClick}
      />
    );
  }

  src(file) {
    if (file.id) {
      return file.path;
    } else {
      return window.URL.createObjectURL(file);
    }
  }
  render() {
    const { filesCount, onClick } = this.props;
    return (
      <Box withoutFile={filesCount <= 0}>
        <div
          className="files-number"
          onClick={
            filesCount > 0
              ? e => {
                  e.stopPropagation();
                  onClick();
                  this.showModal();
                }
              : () => {}
          }
        >
          {filesCount > 0 ? filesCount : "-"}
        </div>
        {this.modalView()}
      </Box>
    );
  }
}
export default Index;
